export default {
    methods: {
        sortPopularList(list) {
            let sortedList = [];

            if (list && list.length > 0) {
                sortedList = list.filter(item => {
                    return item.order != 0;
                });
                sortedList = sortedList.sort((a, b) => {
                    let customSort = function value(el) {
                        let order = parseFloat(el);
                        return order === 0 ? Infinity : order;
                    };
                    return customSort(a.order) - customSort(b.order);
                });
            }

            return sortedList;
        }
    }
};
